import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker";
import { useFilterDate } from "@/common/hooks/useFilterDate";
import { DashboardFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterDateRangeSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const { date } = useFilterDate(filters);

  return (
    <div className="flex items-center justify-between gap-2 p-4 bg-white-100">
      <p className="font-light text-sm italic">
        Data
      </p>

      <DatePickerWithRange
        date={date}
        setDate={(date) => setFilters((params) => ({ ...params, date }))}
        buttonClassName="shadow-none rounded-none min-h-10 bg-transparent"
      />
    </div>
  );
}

export default DashboardFilterDateRangeSheet;
